import { reactive } from 'vue'

export default reactive({
    items: [],
    processedAlerts: new Set(),

    add(alert) {
        // Create a unique identifier for this alert
        const alertId = this.createAlertId(alert)

        // Prevent duplicate alerts
        if (this.processedAlerts.has(alertId)) {
            return
        }

        // Add to processed set
        this.processedAlerts.add(alertId)

        // Add to items
        this.items.unshift({
            key: Symbol(),
            id: alertId,
            timestamp: Date.now(),
            ...alert,
        })

        // Clean up old processed alerts (keep last 50)
        if (this.processedAlerts.size > 50) {
            const oldestAlerts = Array.from(this.processedAlerts).slice(0, 25)
            oldestAlerts.forEach((id) => this.processedAlerts.delete(id))
        }
    },

    remove(index) {
        const alert = this.items[index]
        if (alert) {
            // Remove from processed set after a delay to allow for navigation
            setTimeout(() => {
                this.processedAlerts.delete(alert.id)
            }, 5000)

            this.items.splice(index, 1)
        }
    },

    createAlertId(alert) {
        // Create a unique ID based on alert content and current timestamp window
        // Use 2-second window to prevent rapid duplicates
        const timeWindow = Math.floor(Date.now() / 2000)
        const content = `${alert.type || ''}${alert.title || ''}${alert.description || ''}`
        return `${content}_${timeWindow}`
    },

    clear() {
        this.items = []
        this.processedAlerts.clear()
    },
})
